import React, { ChangeEvent } from 'react';

import { Box, Typography } from '@material-ui/core';

import { AppSearchInput } from '@vyce/core/src/components/inputs';
import { FormTemplateDoc } from '@vyce/core/src/api/types';

import { TemplatesDataGrid } from './TemplatesDataGrid';

interface Props {
  rows: FormTemplateDoc[];
  dragType: string;
  withActions?: boolean;
  isArchivedView?: boolean;
  fillingInTemplateId?: string | null;
  fillingOutTemplateId?: string | null;
  duplicatingTemplateId?: string | null;
  onFillIn?: (template: FormTemplateDoc) => void;
  onSend?: (template: FormTemplateDoc) => void;
  onEditTemplate?: (template: FormTemplateDoc) => void;
  onDuplicateTemplate?: (template: FormTemplateDoc) => void;
  onArchiveTemplate?: (template: FormTemplateDoc) => void;
  onChangeFolder?: (template: FormTemplateDoc) => void;
  onDeleteTemplate?: (template: FormTemplateDoc) => void;
  loading: boolean;
  total: number;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const UnassignedTemplatesSection: React.FC<Props> = ({
  rows,
  dragType,
  withActions = false,
  isArchivedView,
  fillingInTemplateId,
  fillingOutTemplateId,
  duplicatingTemplateId,
  onFillIn,
  onSend,
  onEditTemplate,
  onDuplicateTemplate,
  onArchiveTemplate,
  onChangeFolder,
  onDeleteTemplate,
  loading,
  total,
  onSearchChange,
}) => {
  return (
    <>
      <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={12} marginBottom={2}>
        <Typography variant="h6">Unassigned templates</Typography>
        <AppSearchInput
          placeholder="Search..."
          onChange={onSearchChange}
          isSmall
          smallRounding
          isBorder
          expanded={true}
        />
      </Box>
      <TemplatesDataGrid
        rows={rows}
        enableDragAndDrop
        dragType={dragType}
        withActions={withActions}
        isArchivedView={isArchivedView}
        fillingInTemplateId={fillingInTemplateId}
        fillingOutTemplateId={fillingOutTemplateId}
        duplicatingTemplateId={duplicatingTemplateId}
        onFillIn={onFillIn}
        onSend={onSend}
        onEditTemplate={onEditTemplate}
        onDuplicateTemplate={onDuplicateTemplate}
        onArchiveTemplate={onArchiveTemplate}
        onChangeFolder={onChangeFolder}
        onDeleteTemplate={onDeleteTemplate}
        height="calc(100vh - 320px)"
        loading={loading}
        total={total}
        setOffset={() => {}}
      />
    </>
  );
};
